import React from "react"

import { format } from "date-fns"
import { RefreshCcw, Truck } from "lucide-react"
import { useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { useApplication } from "@/contexts/ApplicationContext"

const VehicleCollectionConfirmation = () => {
  const { application } = useApplication()
  const navigate = useNavigate()
  const collectionDate = application.vehicleCollection?.date
    ? new Date(application.vehicleCollection.date)
    : null
  const handleReschedule = () => {
    navigate("/vehicle-collection")
  }
  return (
    <div className="mx-auto max-w-md">
      <Card>
        <CardHeader className="text-center">
          <div className="mb-4 flex justify-center">
            <div className="rounded-full bg-green-100 p-3">
              <Truck className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <CardTitle className="mb-2 text-xl font-bold text-jungle">
            Collection Confirmed!
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2 rounded-lg bg-gray-50 p-4">
            <h3 className="mb-2 font-medium">Your Vehicle Collection Details</h3>
            {collectionDate && (
              <>
                <p className="text-sm">
                  <span className="font-medium">Date:</span>{" "}
                  {format(collectionDate, "EEEE, MMMM d, yyyy")}
                </p>
                <p className="text-sm">
                  <span className="font-medium">Time:</span> {format(collectionDate, "h:mm a")}
                </p>
              </>
            )}
            <p className="text-sm">
              <span className="font-medium">Location:</span>{" "}
              {application.vehicleCollection.location
                ? `${application.vehicleCollection.location}`
                : "HIVED Operations Center"}
            </p>
          </div>
          <p className="text-center text-sm text-gray-600">
            We're excited to get you on the road! Don't forget to bring your driving license or
            proof of identity.
          </p>
        </CardContent>
        <CardFooter className="flex justify-center pt-4">
          <Button variant="outline" onClick={handleReschedule} className="flex items-center gap-2">
            <RefreshCcw className="h-4 w-4" />
            Reschedule Collection
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
export default VehicleCollectionConfirmation
